import { render, staticRenderFns } from "./RecentActions.vue?vue&type=template&id=7f1365b4&scoped=true&"
import script from "./RecentActions.vue?vue&type=script&lang=js&"
export * from "./RecentActions.vue?vue&type=script&lang=js&"
import style0 from "./RecentActions.vue?vue&type=style&index=0&id=7f1365b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1365b4",
  null
  
)

export default component.exports